<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from 'radix-vue';
import { trackStyle, thumbStyle } from './switchRecipe';

interface Props {
  size?: 'small' | 'large';  
  modelValue?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  modelValue: false
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <SwitchRoot
    :checked="props.modelValue"
    @update:checked="emit('update:modelValue', $event)"
    :class="trackStyle({ size: props.size })"
  >
    <SwitchThumb :class="thumbStyle({ size: props.size })" />
  </SwitchRoot>
</template>